import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import classNames from 'classnames';
import { Fragment, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import Dot from '/@/components/dot';
import Popup from '/@/components/popup';
import References from '/@/components/references';
import colors from '/@/components/theme-provider/colors.js';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Dots from '/@/v3/components/dots';
import { NewDotsReference } from '/@/v3/components/new-dots-reference';
import { RangeReference } from '/@/v3/components/range-reference';
import styles from './styles.module.css';

export default function NewMetricsMobile({ products, dataKey, dots, brand, country }) {
    const referenceCodenames = [];
    if (dots) {
        products.forEach((product) =>
            product.metrics.forEach(
                (metric) =>
                    metric.referenceCodename !== 'default' &&
                    !referenceCodenames.includes(metric.referenceCodename) &&
                    referenceCodenames.push(metric.referenceCodename)
            )
        );
    }
    const useDefaultReference = referenceCodenames.length === 0;

    const [showTooltip, setShowTooltip] = useState(false);
    const [dataToShow, setDataToShow] = useState([]);

    const data = products.map((prod) => {
        return prod[dataKey];
    });

    const showValue = brand.metricsMaxValue === 9;

    let parsedData = [];

    const column = data.map(
        (dat) =>
            dat &&
            dat.map((datum) => {
                return { name: datum.name, references: datum.references };
            })
    );

    column.map((col) => {
        col.map((c) => {
            return parsedData.push({ name: c.name, references: c.references });
        });
    });

    parsedData = Array.from(new Set(parsedData.map(JSON.stringify))).map(JSON.parse);

    function isValInRange(value, rangeArr) {
        const range = rangeArr.find((ra) => {
            return value >= ra[0] && value <= ra[1];
        });
        return rangeArr.indexOf(range);
    }

    const handleShowTooltip = (d) => {
        setShowTooltip(true);
        setDataToShow(d);
    };

    const hasReference = (data, p) => {
        const ref = [];
        if (p.references && p.references.length) {
            let references = p.references;
            references = references.map((r) => {
                const min = r.min !== null ? r.min : Number.NEGATIVE_INFINITY;
                const max = r.max !== null ? r.max : Number.POSITIVE_INFINITY;
                return ref.push([min, max]);
            });
            return isValInRange(data, ref);
        }
    };

    const writtenValue = (val, value) => {
        const referenceIndex = hasReference(_(val), value);
        let doubleReference = _(val).split('-');
        doubleReference = doubleReference.filter((r) => r !== '');

        return ['CONSULTE A BULA', 'VER FOLLETO', 'SEE BROCHURE'].some((el) => el == _(val).toUpperCase()) ? (
            <a
                className={styles.link}
                href='https://agrofit.agricultura.gov.br/agrofit_cons/principal_agrofit_cons'
                target='_blank'
                rel='noreferrer'
            >
                {`${_(val)}*`}
            </a>
        ) : doubleReference.length === 2 ? (
            <div style={{ display: 'flex', justifyContent: 'end', gap: 5 }}>
                {doubleReference.map((r, i) => {
                    const referenceI = hasReference(r, value);
                    return (
                        <div
                            className={classNames(
                                (Boolean(referenceI >= 0) || (value.references && value.references.length === 4)) &&
                                    styles.referenceContainer,
                                styles.doubleReference
                            )}
                        >
                            <ReactMarkdown
                                className={classNames(
                                    styles.markdown,
                                    styles.doubleReference,
                                    (Boolean(referenceI >= 0) || (value.references && value.references.length === 4)) &&
                                        styles.references,
                                    (Boolean(referenceI >= 0) || (value.references && value.references.length === 4)) &&
                                        styles[
                                            `reference-${
                                                value.references && value.references.length === 3
                                                    ? 'other'
                                                    : value.references && value.references.length === 4
                                                      ? 'toxicology'
                                                      : 'default'
                                            }-${value.references && value.references.length === 4 ? r : referenceI}`
                                        ]
                                )}
                            >
                                {r}
                            </ReactMarkdown>
                            {r !== doubleReference[doubleReference.length - 1] && ' - '}
                        </div>
                    );
                })}
            </div>
        ) : (
            <div
                className={
                    (Boolean(referenceIndex >= 0) || (value.references && value.references.length === 4)) &&
                    styles.referenceContainer
                }
            >
                <ReactMarkdown
                    className={classNames(
                        styles.markdown,
                        (Boolean(referenceIndex >= 0) || (value.references && value.references.length === 4)) &&
                            styles.references,
                        (Boolean(referenceIndex >= 0) || (value.references && value.references.length === 4)) &&
                            styles[
                                `reference-${
                                    value.references && value.references.length === 3
                                        ? 'other'
                                        : value.references && value.references.length === 4
                                          ? 'toxicology'
                                          : 'default'
                                }-${value.references && value.references.length === 4 ? _(val) : referenceIndex}`
                            ]
                    )}
                >
                    {_(val)}
                </ReactMarkdown>
            </div>
        );
    };

    return (
        <Fragment>
            <Fragment>
                {dots && (
                    <Grid sx={{ paddingBottom: 4 }} container justifyContent='center' alignItems='center'>
                        <Grid item xs={12}>
                            {useDefaultReference ? (
                                <NewDotsReference brand={brand} country={country} />
                            ) : (
                                <RangeReference
                                    hideTitle
                                    maxWidth={false}
                                    referenceCodenames={referenceCodenames}
                                    theme={brand.theme}
                                />
                            )}
                        </Grid>
                    </Grid>
                )}
            </Fragment>
            {parsedData.map((dat) => {
                return (
                    <div className={styles.table}>
                        <div className={styles.metricTitle}>
                            {_(dat.name)}
                            {Boolean(dat.references && dat.references.length) && (
                                <span
                                    onClick={() => handleShowTooltip(dat)}
                                    style={{ fontSize: '16px' }}
                                    className='material-icons'
                                >
                                    info
                                </span>
                            )}
                        </div>
                        <TableContainer sx={{ width: '100%', boxShadow: 'none', overflow: 'hidden' }} component={Paper}>
                            <Table aria-label='simple table'>
                                <TableBody>
                                    {products.map((prod) => {
                                        const value = prod?.[dataKey]?.find((p) => {
                                            return _(p.name) === _(dat.name);
                                        });
                                        return (
                                            <TableRow
                                                key={_(prod.id)}
                                                sx={{
                                                    fontSize: 14,

                                                    td: {
                                                        borderTop: '1px solid #F8F8F8',
                                                        borderLeft: 0,
                                                        borderBottom: 'none',
                                                        padding: '0 30px',
                                                    },
                                                    ...(prod.id == products?.[0]?.id &&
                                                        products.length > 1 && {
                                                            backgroundColor:
                                                                colors.themes[settings.app.theme].primary[100],
                                                        }),
                                                }}
                                            >
                                                <TableCell align='left' sx={{ position: 'relative' }}>
                                                    <ReactMarkdown className={styles.markdown}>
                                                        {prod.product.catalogName
                                                            ? prod.product.catalogName
                                                            : prod.product.name}
                                                    </ReactMarkdown>
                                                </TableCell>
                                                <TableCell align='right' sx={{ position: 'relative' }}>
                                                    {value ? (
                                                        dataKey === 'metrics' ? (
                                                            <Fragment>
                                                                {country.code === 'BR' || country.code === 'PY' ? (
                                                                    <Dots
                                                                        max={brand.metricsMaxValue}
                                                                        center
                                                                        value={Number(_(_(value.value)))}
                                                                        showValues={showValue}
                                                                    />
                                                                ) : (
                                                                    <Dot
                                                                        max={brand.metricsMaxValue}
                                                                        showValue={showValue}
                                                                        value={_(value.value)}
                                                                    />
                                                                )}
                                                            </Fragment>
                                                        ) : (
                                                            writtenValue(value.value, value)
                                                        )
                                                    ) : (
                                                        '-'
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                );
            })}
            <Popup
                visible={showTooltip}
                borderRadius
                showCloseIcon
                className={styles.popup}
                onClose={() => setShowTooltip(false)}
            >
                <References product={dataToShow} />
            </Popup>
        </Fragment>
    );
}
